var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents contents--list"},[_vm._m(0),_vm._v(" "),_c('Table',{attrs:{"width":"900px","data-type":"richaccounts","data":_vm.richaccounts}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents--list-subject"},[_c('span',[_vm._v("RichAccountsList")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afe3190","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/RichAccountsList.vue
// module id = 372
// module chunks = 0